import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as mealTypeActions from 'PointOfSale/modules/mealTypes/state/actions';
import MealsTypesSideBarComponent from 'PointOfSale/modules/layouts/component/pageSidebar/MealsTypesSideBar';

class MealsTypesSideBar extends Component {
  render() {
    const { currentSelectedMenu } = this.props;
    return (
      <MealsTypesSideBarComponent
        currentSelectedMenu={currentSelectedMenu}
        routes={this.props.location}
        history={this.props.history}
      />
    );
  }
}

MealsTypesSideBar.propTypes = {
  currentSelectedMenu: PropTypes.string,
  mealTypesActions: PropTypes.shape({
    reset: PropTypes.func
  })
};
const mapStateToProps = state => ({
  currentSelectedMenu: state.PointOfSaleState.mealTypes.currentSelectedMenu
});

const mapDispatchToProps = dispatch => ({
  mealTypesActions: bindActionCreators(mealTypeActions, dispatch)
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(MealsTypesSideBar)
);



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/layouts/container/pageSidebar/MealsTypesSideBar.js